import { Component } from 'react'
import isEmpty from 'lodash/isEmpty'
import isEqual from 'lodash/isEqual'
import PropTypes from 'prop-types'

import QuoteOverview from '../../quoteList/QuoteList'
import QuoteSingleView from '../../quoteSingle/QuoteSingleView'
import classNames from './styles.module.scss'


const propTypes = {
  data: PropTypes.array.isRequired,
}

export default class QuotePrintView extends Component {
  shouldComponentUpdate(nextProps) {
    if(isEqual(nextProps.data, this.props.data)) {
      return false
    }
    return true
  }

  render() {
    const { data } = this.props
    return (
      <div className={classNames.printOnly}>
        <QuoteOverview withoutHeader />
        {!isEmpty(data) && data.map((item, index) => (
          <QuoteSingleView key={item.id} option={item} optionIndex={index + 1} isPrintView withoutButton />
        ))}
      </div>
    )
  }
}

QuotePrintView.propTypes = propTypes
